/* global ace, Modernizr, bugsnagClient  */

import $ from 'jquery'
import Cookies from 'js-cookie'

import find from 'lodash-es/find'
import forEach from 'lodash-es/forEach'
import forIn from 'lodash-es/forIn'
import keys from 'lodash-es/keys'
import map from 'lodash-es/map'
import pick from 'lodash-es/pick'
import reject from 'lodash-es/reject'

import { Curtain } from './curtain'
import { openInEditorModal } from './open-in-editor-modal'
import { Popup } from './popup'
import { MessageOverlay } from './message-overlay'
import { Forms } from './forms'
import { isValidEmail } from './helpers'

const debug = require('debug')('pm:templates')
debug('loaded')

let $editorForm

const Templates = {
  init: function () {
    debug('init')

    $editorForm = $('.js-template-editor-form')

    Templates.loadThumbnails()
    Templates.createEditors()

    // Set some states
    Templates.pendingChanges
    Templates.isPreviewSizeLabelActive
    Templates.jsonEditorSizeOffset = 150
    Templates.isModelActive = false
    Templates.disableLinksInStarterTemplates()

    // Events
    $('.js-fullscreen').on('click', Templates.toggleFullscreen)
    $('.js-editor-mode').on('click', Templates.switchEditorMode)
    $('.js-edit-type').on('click', Templates.switchEditType)
    $('.js-preview-type').on('click', Templates.switchPreviewType)
    $('.js-toggle-model').on('click', Templates.togglePreviewModel)
    $('.js-snippets-popup').on('click', Templates.snippetPopup)
    $('.template-title_field').on('change', Templates.enableSave)
    $('.template-masthead').on(
      'input',
      'input[type="text"]',
      Templates.enableSave
    )
    $('.template-editor-form').on('submit', Templates.save)
    $(document).on('pendingChangesEvent', Templates.pendingChangeEventHandler)
    $(document).on('submit', '.js-template-test-form', Templates.sendTest)
    $(document).on(
      'submit',
      '.js-template-test-form-server-admin',
      Templates.sendTestForServerAdmin
    )
    $(document).on('editorReadyEvent', Templates.checkPreview)
    $(document).on('editorReadyEvent', Templates.collapseStyleBlocks)
    $(document).on('click', '.js-template-layout-pref', Templates.layoutPref)
    $(document).on('submit', '.js-alias-form', Templates.aliasForm)
    $(document).on('change', '.js-layout', Templates.layoutChange)
    $(document).on(
      'click',
      '.js-layout-placeholder',
      Templates.layoutPlaceholder
    )

    // Only fire global events if template editor is present
    if ($('.template-editor-form').length) {
      $(window).on('resize', Templates.windowResize)
      $(window).on('keyup', Templates.keyupHandler)
      $(window).on('beforeunload', Templates.pendingChangesPageUnload)
    }

    // Compile preview if ace editor exists
    if (typeof ace !== 'undefined') {
      Templates.compilePreview(true)
    }

    $('.js-template-search').on(
      'autocomplete:selected',
      function (event, item) {
        if (item.visual_duplicate_url) {
          openInEditorModal(item.url, item.visual_duplicate_url)
          return
        }

        window.location.href = item.url
      }
    )
  },

  layoutPref: function (event) {
    event.preventDefault()
    const layout = $(this).data('layout')

    debug('layout', layout)

    Cookies.set('template_layout_pref', layout, { samesite: 'Lax' })
    location.reload()
  },

  thumbnailLoaded: function (el) {
    $(el)
      .next('.template-thumb_loader, .item-thumb_loader')
      .fadeOut(300, function () {
        $(el).removeClass('u-is-loading--small u-is-loading')
      })

    $(el).fadeIn(400)
  },

  loadThumbnails: function () {
    $('.js-load-thumb').each(function (index, el) {
      const templatePath = $(this).data('src')

      $(el)
        .attr('src', templatePath + '?' + Date.now())
        .hide()

      setTimeout(function () {
        Templates.thumbnailLoaded(el)
      }, 1000)
    })
  },

  toggleFullscreen: function (event) {
    event.preventDefault()

    $('.js-fullscreen').toggleClass('editor-fullscreen--exit')
    $('body').toggleClass('fullscreen')
    $('.code-editor').toggleClass('fullscreen-editor')

    Templates.editorHtml.resize()
    Templates.editorText.resize()
    Templates.editorJson.resize()
    Templates.scaleSplitPane()

    if (Templates.isModelActive) {
      Templates.refreshSplitPane()
    }

    Templates.refreshSizeLabel()
  },

  createEditors: function () {
    if (typeof ace !== 'undefined' && $('.code-editor').length) {
      // Include editor modes
      const TextMode = ace.require('ace/mode/text').Mode
      const JsonMode = ace.require('ace/mode/json').Mode

      // Create HTML editor
      Templates.editorHtml = ace.edit('ace-editor--html')
      setupHtmlEditor(Templates.editorHtml, !!getCurrentLayoutAlias())

      // Create Text editor
      Templates.editorText = ace.edit('ace-editor--text')
      setupEditor(Templates.editorText, new TextMode())

      // Create JSON editor
      Templates.editorJson = ace.edit('ace-editor--json')
      setupEditor(Templates.editorJson, new JsonMode())

      Templates.bindEditorEvents()

      setTimeout(function () {
        const editorToDisplay = $('.template-type-toggle').hasClass(
          'template-type-toggle--text'
        )
          ? '#ace-editor--text'
          : '#ace-editor--html'
        $(editorToDisplay).fadeIn(100, function () {
          $('.code-editor').removeClass('code-editor--loading')
          $(document).trigger('editorReadyEvent')
        })
      }, 500)

      Templates.createPreview()
    }
  },

  switchEditorMode: function (event) {
    event.preventDefault()

    const activeButtonClass = 'mode-button--active',
      activeViewClass = 'mode-view--active',
      target = $(this).data('target')

    if (!$(this).hasClass(activeButtonClass)) {
      // Swap buttons
      $('.js-editor-mode').removeClass(activeButtonClass)
      $(this).addClass(activeButtonClass)

      // Swap views
      $('.mode-view').removeClass(activeViewClass)
      $('.mode-view[data-mode-view="' + target + '"]').addClass(activeViewClass)

      Templates.editorHtml.resize()
      Templates.editorText.resize()

      // Update previews
      if (target === 'preview') {
        Templates.refreshSizeLabel()
        Templates.compilePreview(true)
      } else {
        $('.preview-error-wrapper').hide()

        // Only for non touch devices
        if (!Modernizr.touchevents) {
          // Set focus on current editor
          if ($('.js-edit-type').hasClass('template-type-toggle--html')) {
            Templates.editorHtml.focus()
          } else {
            Templates.editorText.focus()
          }
        }
      }
    }
  },

  switchEditType: function (event) {
    event.preventDefault()

    const htmlActive = 'template-type-toggle--html',
      textActive = 'template-type-toggle--text',
      htmlEditor = '#ace-editor--html',
      textEditor = '#ace-editor--text',
      timing = 100

    if ($(this).hasClass(htmlActive)) {
      Templates.activeEditor = 'text'

      $(this).removeClass(htmlActive).addClass(textActive)

      $(htmlEditor).fadeOut(timing, function () {
        $(textEditor).show().fadeIn(timing)
        Templates.editorText.focus()
      })
    } else {
      Templates.activeEditor = 'html'

      $(this).removeClass(textActive).addClass(htmlActive)

      $(textEditor).fadeOut(timing, function () {
        $(htmlEditor).fadeIn(timing)
        Templates.editorHtml.focus()
      })
    }
  },

  switchPreviewType: function (event) {
    event.preventDefault()

    const htmlActive = 'template-type-toggle--html',
      textActive = 'template-type-toggle--text',
      htmlEditor = '.preview-html',
      textEditor = '.preview-text',
      timing = 100

    if ($(this).hasClass(htmlActive)) {
      $(this).removeClass(htmlActive).addClass(textActive)

      $(htmlEditor).fadeOut(timing, function () {
        $(textEditor).show().fadeIn(timing)
      })
    } else {
      $(this).removeClass(textActive).addClass(htmlActive)

      $(textEditor).fadeOut(timing, function () {
        $(htmlEditor).fadeIn(timing)
      })
    }
  },

  bindEditorEvents: function () {
    Templates.editorHtml.getSession().on('change', Templates.enableSave)
    Templates.editorText.getSession().on('change', Templates.enableSave)
    Templates.editorJson
      .getSession()
      .on('change', Templates.previewEditorChangeHandler)
    Templates.editorJson.on('paste', Templates.previewEditorChange)
    $('.js-template-subject').on(
      'input',
      Templates.previewEditorChangeAndReload
    )

    Templates.editorHtml
      .getSession()
      .on('change', Templates.previewEditorChangeAndReload)
    Templates.editorText
      .getSession()
      .on('change', Templates.previewEditorChangeAndReload)
  },

  pendingChangesPageUnload: function (event) {
    if (
      Templates.pendingChanges &&
      !event.target.activeElement.classList.contains('save-template')
    ) {
      return 'You have unsaved changes.'
    }
  },

  keyupHandler: function (event) {
    // ESC key
    if (event.keyCode === 27 && $('body').hasClass('fullscreen')) {
      Templates.toggleFullscreen(event)
    }
  },

  enableSave: function () {
    $.event.trigger({
      type: 'pendingChangesEvent',
      message: true,
      time: new Date(),
    })
    $('.save-template').prop('disabled', false)
  },

  pendingChangeEventHandler: function (event) {
    const el = $('.js-send-test, .js-duplicate'),
      tooltipClass = 'js-tooltip-disable',
      popupClass = 'js-popup-disable is-disabled'

    Templates.pendingChanges = event.message ? true : false

    if (Templates.pendingChanges) {
      el.removeClass(tooltipClass).addClass(popupClass)
    } else {
      el.addClass(tooltipClass).removeClass(popupClass)
    }
  },

  save: function (event) {
    event.preventDefault()

    Templates.softValidateEditors()

    const type = $editorForm.data('template-type')
    const isValid =
      type === 'layout'
        ? Templates.validLayoutFields()
        : Templates.validTemplateFields()

    // Validate name and subject fields
    if (isValid) {
      $('.save-template').prop('disabled', true)
      $('.code-editor').addClass('code-editor--loading')

      //Populate real input fields with values from editor
      $('#template_html_body').val(Templates.editorHtml.getValue())
      $('#template_text_body').val(Templates.editorText.getValue())

      $.ajax({
        url: $(this).attr('action'),
        data: $(this).serialize(),
        method: 'POST',
        success: function () {
          $('.saved-notification').classTransition('animateIn')
          $.event.trigger({
            type: 'pendingChangesEvent',
            message: false,
            time: new Date(),
          })

          Templates.clearOutPostmarkAnnotations(
            Templates.editorText.getSession()
          )
          Templates.clearOutPostmarkAnnotations(
            Templates.editorHtml.getSession()
          )
        },
        error: function (response) {
          const el = $('.preview-error').clone()

          Templates.showTemplateError(response, el, function (target) {
            $('#popup .wrapper').append(target)
            Curtain.show()
            $('#popup')
              .addClass('template-error-popup')
              .removeClass('u-is-loading')
              .showMe()
            $('.template-error-popup .preview-error_title').text(
              "Your template wasn't saved because we found some issues."
            )
            $('.b-close-popup').showMe()
            Popup.refresh()
            $('body').css({ overflow: 'hidden' })
          })

          $('.save-template').prop('disabled', false)
        },
        complete: function () {
          $('.code-editor').removeClass('code-editor--loading')
        },
      })
    }
  },

  clearOutPostmarkAnnotations: function (editorSession) {
    const nonPostmarkErrors = reject(editorSession.getAnnotations(), 'postmark')
    editorSession.setAnnotations(nonPostmarkErrors)
  },

  softValidateEditors: function () {
    function animateIn(el) {
      el.animate(
        {
          width: '15px',
          opacity: '1',
        },
        100,
        function () {
          $(this).addClass('toggle-warning--active')
        }
      )
    }

    function animateOut(el) {
      el.animate(
        {
          width: '0px',
          opacity: '0',
        },
        100,
        function () {
          $(this).removeClass('toggle-warning--active')
        }
      )
    }

    const textToggle = $('.type-toggle_text')

    // Check Text editor
    Templates.editorText.getValue() === ''
      ? animateIn(textToggle.find('.toggle-warning'))
      : animateOut(textToggle.find('.toggle-warning'))
  },

  validTemplateFields: function () {
    const errors = []
    const $name = $('.js-template-name')
    const $nameRow = $name.parents('.c-form-row')
    const $subject = $('.js-template-subject')
    const $subjectRow = $subject.parents('.c-form-row')

    if ($name.val() === '') {
      $nameRow.addClass('error')
      errors.push('name')
    } else {
      $nameRow.removeClass('error')
    }

    if ($subject.val() === '') {
      $subjectRow.addClass('error')
      errors.push('subject')
    } else {
      $subjectRow.removeClass('error')
    }

    return errors.length === 0
  },

  validLayoutFields: function () {
    const $name = $('.js-layout-name')
    const $nameRow = $name.parents('.c-form-row')
    let isValid = false

    if ($name.val() === '') {
      $nameRow.addClass('error')
    } else {
      $nameRow.removeClass('error')
      isValid = true
    }

    return isValid
  },

  createPreview: function () {
    try {
      $('.pane_frame')
        .contents()
        .find('html')
        .html(Templates.editorHtml.getValue())
    } catch (e) {
      if (typeof bugsnagClient !== 'undefined') bugsnagClient.notify(e)
      console.error(e)
    }

    $('.preview-text pre').text(Templates.editorText.getValue())

    Templates.splitPane = $('.pane-split')
    Templates.scaleSplitPane()
  },

  togglePreviewModel: function (event) {
    event.preventDefault()

    if (!Templates.isModelActive) {
      // Update flags
      $(this).toggleClass('is-active')
      Templates.isModelActive = true
      Templates.scaleSplitPane()

      // Create splitter
      Templates.splitPane.split({
        orientation: 'vertical',
        limit: Templates.jsonEditorSizeOffset,
        position: Templates.lastModelWidth
          ? $('.pane-split').width() - Templates.lastModelWidth
          : '60%',
      })

      $('.model-editor').show()
      Templates.editorJson.resize()
      Templates.editorJson.focus()
      Templates.bindSplitterEvents()
    } else {
      Templates.lastModelWidth = $('.model-editor').width()

      // Update flags
      $(this).toggleClass('is-active')
      Templates.isModelActive = false

      // Destroy and hide
      Templates.splitPane.split().destroy()
      $('.model-editor').hide()
    }

    Templates.refreshSizeLabel()
  },

  bindSplitterEvents: function () {
    let splitterActive

    $(document.documentElement)
      .on('mousedown.splitter', function () {
        splitterActive = true
      })
      .on('mouseup.splitter', function () {
        splitterActive = false
      })
      .on('mousemove.splitter', function () {
        if (splitterActive) {
          Templates.editorJson.resize()
          Templates.refreshSizeLabel()
        }
      })
  },

  windowResize: function () {
    Templates.refreshSizeLabel()
    Templates.scaleSplitPane()
  },

  compilePreview: function (reloadJsonEditor) {
    // Update preview pane content
    function updatePreviewContent(html, text, subject, suggested) {
      $('.pane_frame').contents().find('html').get(0).innerHTML = html
      $('.preview-text pre').text(text)
      $('.preview-subject_field').text(subject)

      // Disable links in preview
      $('.pane_frame')
        .contents()
        .find('a')
        .on('click', function (event) {
          event.preventDefault()
        })

      if (reloadJsonEditor && !!suggested) {
        const existing = JSON.parse(Templates.editorJson.getValue()),
          merged = $.extend(true, suggested, pick(existing, keys(suggested)))

        Templates.editorJson.setValue(JSON.stringify(merged, null, '\t'), 1)
      }
    }

    // Make sure the preview model is valid
    if (Templates.isPreviewModelValid()) {
      $('.pane_preview').addClass('pane_preview--loading')

      // Request data
      const request = {
        html_body: Templates.editorHtml.getValue(),
        text_body: Templates.editorText.getValue(),
        subject: $('#template_subject').val(),
        layout_template_alias: $('.js-layout:checked').val() || null,
        template_type: $editorForm.data('template-type'),
        test_render_model: JSON.parse(Templates.editorJson.getValue()),
      }

      // Compile template
      $.ajax({
        url: $('.js-preview-url').val(),
        method: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify(request),
        success: function (response) {
          // eslint-disable-next-line @typescript-eslint/camelcase
          const html_content = response.html_body
            ? response.html_body.rendered_content
            : ''
          // eslint-disable-next-line @typescript-eslint/camelcase
          const text_content = response.text_body
            ? response.text_body.rendered_content
            : ''
          // eslint-disable-next-line @typescript-eslint/camelcase
          const subject_content = response.subject
            ? response.subject.rendered_content
            : ''

          $('.preview-error-wrapper').hide()
          updatePreviewContent(
            html_content,
            text_content,
            subject_content,
            response.suggested_template_model
          )

          Templates.clearOutPostmarkAnnotations(
            Templates.editorText.getSession()
          )
          Templates.clearOutPostmarkAnnotations(
            Templates.editorHtml.getSession()
          )
        },
        error: function (response) {
          Templates.showTemplateError(response, $('.preview-error-wrapper'))
          $('.pane_frame').contents().find('html').empty()
        },
        complete: function () {
          $('.pane_preview').removeClass('pane_preview--loading')
        },
      })
    }
  },

  showTemplateError: function (response, targetEl, callback) {
    targetEl.find('.error-list').remove()
    const errorList = $('<div />').addClass('error-list'),
      errorWrapper = targetEl.find('.preview-error').length
        ? targetEl.find('.preview-error')
        : targetEl

    errorWrapper.append(errorList)

    if (response.status === 422) {
      const group = $('<div class="error-group" />')

      const errorTypeInfo = {
        html_body: { label: 'HTML version', editor: Templates.editorHtml },
        text_body: { label: 'Text version', editor: Templates.editorText },
        subject: { label: 'Subject line' },
        base: { label: 'General' },
      }

      forIn(response.responseJSON, function (errors, key) {
        let newAnnotations = []
        if (errors) {
          const el = group.clone()
          el.append($('<h5 />').text(errorTypeInfo[key].label))

          if (typeof errors === 'string' || errors instanceof String) {
            el.append($('<p />').text(errors))
            errorList.append(el)
            return
          }

          forEach(errors, function (value) {
            el.append($('<p />').text(formatErrorMessage(value)))
            errorList.append(el)
          })

          if (errorTypeInfo[key].editor && errors.length > 0) {
            newAnnotations = map(errors, function (err) {
              return {
                row: err.line - 1,
                column: err.character_position,
                text: err.message,
                type: 'error',
                postmark: true,
              }
            })
          }
        }

        if (errorTypeInfo[key].editor) {
          const existingAnnotations = reject(
            errorTypeInfo[key].editor.getSession().getAnnotations(),
            'postmark'
          )
          errorTypeInfo[key].editor
            .getSession()
            .setAnnotations(existingAnnotations.concat(newAnnotations))
        }
      })
    } else {
      // Show generic response text error
      errorList.append($('<p />').text(response.responseText))
    }

    targetEl.show()

    if (callback) {
      callback(targetEl)
    }
  },

  refreshSizeLabel: function () {
    const previewSizeEl = $('.preview-size'),
      pane = $('.preview-html')

    $('.preview-size_width-value').html(Math.round(pane.width()))
    $('.preview-size_height-value').html(Math.round(pane.height()))

    // Show label if it isn't already active
    if (!Templates.isPreviewSizeLabelActive) {
      Templates.isPreviewSizeLabelActive = true
      previewSizeEl.fadeIn()
    }

    // Reset timeout
    window.clearTimeout(Templates.doneResizingPreview)

    Templates.doneResizingPreview = setTimeout(function () {
      Templates.isPreviewSizeLabelActive = false
      previewSizeEl.fadeOut()
    }, 3000)
  },

  refreshSplitPane: function () {
    const previewMode = $('.mode-view--preview'),
      previewPane = $('.pane_preview')

    // Check if preview pane is larger than container
    if (
      previewPane.width() + Templates.jsonEditorSizeOffset >
      previewMode.width()
    ) {
      // Destroy and recreate slitter
      Templates.splitPane.split().destroy()
      Templates.scaleSplitPane()
      Templates.splitPane.split({
        orientation: 'vertical',
        limit: Templates.jsonEditorSizeOffset,
        position: '70%',
      })

      Templates.bindSplitterEvents()
    } else {
      Templates.scaleSplitPane()
      Templates.splitPane.split().refresh()
    }

    Templates.editorJson.resize()
    Templates.refreshSizeLabel()
  },

  scaleSplitPane: function () {
    const parent = $('.mode-view--preview')
    Templates.splitPane.width(parent.width()).height(parent.height() - 54)
  },

  previewEditorChangeHandler: function () {
    if (Templates.editorJson.curOp && Templates.editorJson.curOp.command.name) {
      Templates.previewEditorChange()
    }
  },

  previewEditorChange: function () {
    window.clearTimeout(Templates.doneEditingModel)
    Templates.doneEditingModel = setTimeout(function () {
      Templates.compilePreview(false)
    }, 2000)
  },

  previewEditorChangeAndReload: function () {
    window.clearTimeout(Templates.doneEditingModel)
    Templates.doneEditingModel = setTimeout(function () {
      Templates.compilePreview(true)
    }, 2000)
  },

  isPreviewModelValid: function () {
    const annotations = Templates.editorJson.getSession().getAnnotations(),
      errors = find(annotations, { type: 'error' }) || false

    if (errors) {
      return false
    }

    const content = Templates.editorJson.getValue() || ''
    if (content.trim() === '') {
      return false
    }

    return true
  },

  sendTest: function (event) {
    event.preventDefault()

    const $form = $(this)
    const $submit = $form.find('input[type="submit"]')
    const $emailField = $form.find('.js-test-email')
    const $signature = $form.find('[name=selected_signature]')
    const $popup = $('#popup')

    // Set states
    $popup.addClass('u-is-loading')
    $submit.prop('disabled', true)

    // Validate JSON model
    if (Templates.isPreviewModelValid()) {
      // Validate name input
      if ($emailField.val() !== '' && isValidEmail($emailField.val())) {
        $emailField.parents('.c-form-row').removeClass('error')

        const data = {
          recipient: $emailField.val(),
          signature: $signature.val(),
          template_model: JSON.parse(Templates.editorJson.getValue()),
        }

        // Make request
        $.ajax({
          url: $form.attr('action'),
          method: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(data),
        })
          .done(function () {
            // Close popup and show success message
            Popup.close(event)
            MessageOverlay.show(
              'A test email was sent to ' + $emailField.val() + '.'
            )
          })
          .fail(function (response) {
            // Show popup form error
            Templates.showPopupFormError($form, response.responseText)

            // Remove loading class and enable submit button
            $popup.removeClass('u-is-loading')
            $submit.prop('disabled', false)
          })
      } else {
        // If the email address is invalid
        Templates.showPopupFormError(
          $form,
          'Invalid email address',
          $emailField
        )

        // Update state to allow user to enter new email address
        $popup.removeClass('u-is-loading')
        $emailField.parents('.c-form-row').addClass('error')
        $submit.prop('disabled', false)
      }
    } else {
      // Test variables are invalid
      Templates.showPopupFormError(
        $form,
        'Your test variables must be valid before sending a test email.'
      )

      // Reset states
      $popup.removeClass('u-is-loading')
      $submit.prop('disabled', false)
    }
  },

  // TODO: This is a short-term solution to make it so server admins can send test emails
  // TODO: Needs to be eventually be combined with sendTest and duplicate methods
  sendTestForServerAdmin: function (event) {
    event.preventDefault()
    const $form = $(this)
    const errors = []

    function showFieldError($field) {
      $field.parents('.c-form-row').addClass('error')
      Templates.showPopupFormError($form, 'Invalid email address', $field)
      errors.push($field)
    }

    const $submit = $form.find('input[type="submit"]')
    const $emailField = $form.find('.js-test-email')
    const $emailFromField = $form.find('.js-test-from-email')
    const $popup = $('#popup')

    // Set states
    $popup.addClass('u-is-loading')
    $submit.prop('disabled', true)

    // Validate JSON model
    if (Templates.isPreviewModelValid()) {
      // Validate fields

      if (!isValidEmail($emailFromField.val())) showFieldError($emailFromField)
      if (!isValidEmail($emailField.val())) showFieldError($emailField)

      // Check if there are validation errors
      if (errors.length === 0) {
        $emailField.parents('.c-form-row').removeClass('error')

        const data = {
          recipient: $emailField.val(),
          signature: $emailFromField.val(),
          template_model: JSON.parse(Templates.editorJson.getValue()),
        }

        // Make request
        $.ajax({
          url: $form.attr('action'),
          method: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(data),
        })
          .done(function () {
            Popup.close(event)
            MessageOverlay.show(
              'A test email was sent to ' + $emailField.val() + '.'
            )
          })
          .fail(function (xhr) {
            const err = xhr.responseText
            // Show popup form error
            Templates.showPopupFormError($form, err)

            // Remove loading class and enable submit button
            $popup.removeClass('u-is-loading')
            $submit.prop('disabled', false)
          })
      } else {
        // Update state to allow user to enter new email address
        $popup.removeClass('u-is-loading')
        $submit.prop('disabled', false)
      }
    } else {
      // Test variables are invalid
      Templates.showPopupFormError(
        $form,
        'Your test variables must be valid before sending a test email.'
      )

      // Reset states
      $popup.removeClass('u-is-loading')
      $submit.prop('disabled', false)
    }
  },

  showPopupFormError: function ($form, error, $field) {
    const $formError = $('<div />').addClass(
      'c-form-row_error c-form-row_error--stacked'
    )
    const errorMessage =
      error || 'There was an error making this request. Please try again.'

    // If there's a field, show the error around it
    // Otherwise show the error at the top of the form
    if ($field) {
      const $existingFormError = $field
        .parents('.c-form-row')
        .find('.c-form-row_error')

      // Set error message
      $('<p />').text(errorMessage).appendTo($formError)

      // If there's already an error, update the text
      // If not, add the error to the form row
      $existingFormError.length
        ? $existingFormError.find('p').text(errorMessage)
        : $field.parents('.c-form-row').append($formError)
    } else {
      const $existingFormError = $form.find('.c-form-row_error')

      // Set error message
      $('<p />').text(errorMessage).appendTo($formError)

      // If there's already an error, update the text
      // If not, add the error to the form row
      $existingFormError.length
        ? $existingFormError.find('p').text(errorMessage)
        : $form.prepend($formError)
    }
  },

  checkPreview: function () {
    // Default to preview if URL has preview hash
    if (window.location.hash === '#preview') {
      $('.js-editor-mode[data-target="preview"]').trigger('click')
    }
  },

  snippetPopup: function (event) {
    event.preventDefault()

    const containerClass = $(this).data('container-class')
    Popup.open()

    if (Templates.isPreviewModelValid()) {
      const data = { model: JSON.parse(Templates.editorJson.getValue()) }
      $.ajax({
        method: 'POST',
        url: $(this).attr('href'),
        contentType: 'application/json',
        data: JSON.stringify(data),
        success: function (response) {
          $('#popup').addClass(containerClass)
          Popup.showContent(response)
        },
        error: function () {
          Popup.showError(
            'There was an error fetching the snippets. Please try again.'
          )
        },
      })
    } else {
      Popup.showError(
        'Your test variables must be valid before generating API snippets.'
      )
    }
  },

  collapseStyleBlocks: function () {
    // Ace editor doesn't provide a built-in onready event
    setTimeout(function () {
      const session = Templates.editorHtml.getSession()

      // Iterate through each line
      for (let i = 0; i < session.getLength(); i++) {
        // Check if it's the start of a fold and a style block
        if (
          session.foldWidgets[i] === 'start' &&
          session.getLine(i).search(/<style.*?>/gi) > -1
        ) {
          const range = session.getFoldWidgetRange(i)
          if (range) session.addFold('...', range)
        }
      }
    }, 500)
  },

  aliasForm: function (event) {
    event.preventDefault()

    const $popup = $('#popup')
    const $form = $(this)
    $popup.addClass('u-is-loading')

    $.ajax({
      url: $form.attr('action'),
      data: $form.serialize(),
      type: 'PUT',
    })
      .done(function () {
        const newAlias = $form.find('input[type="text"]').val()
        $('.js-alias-link').text(newAlias)
        $(document).trigger('pmTemplateAliasUpdated', [newAlias])

        Popup.close(event)
        MessageOverlay.show('Template alias saved. 👍')
        $('.js-alias-label').removeClass('hidden')
      })
      .fail(function (response) {
        Forms.showError($form.find('.c-form-row'), response.responseJSON.base)
        $popup.removeClass('u-is-loading')
      })
      .always(function () {
        $form.find('input[type="submit"]').prop('disabled', false)
      })
  },

  disableLinksInStarterTemplates() {
    $(document).on('popupContentLoaded', e => {
      debug('handle "popupContentLoaded"')

      const $popup = $(e.target)

      // Disable links in preview
      $popup.find('.js-disable-preview-links').on('load', function () {
        $(this)
          .contents()
          .find('a')
          .on('click', function (event) {
            debug('preventing click')
            event.preventDefault()
          })
      })
    })
  },

  layoutChange: function () {
    // Update button
    const $button = $('.js-layout-button')
    const name = $(this).data('name')
    $button.text(name)

    // Pending template changes
    Templates.enableSave()

    setupHtmlEditor(Templates.editorHtml, !!getCurrentLayoutAlias())

    // Compile preview
    Templates.compilePreview(false)
  },

  layoutPlaceholder: function (event) {
    event.preventDefault()

    const placeholder = '{{{ @content }}}'
    const editor =
      Templates.activeEditor === 'text'
        ? Templates.editorText
        : Templates.editorHtml
    const cursor = editor.getCursorPosition()

    editor.getSession().insert(cursor, placeholder)
  },
}

function getCurrentLayoutAlias() {
  return $('.js-layout:checked').val()
}

/**
 * @param {object} editor - Ace editor
 * @param {boolean} templateHasLayout - is the template linked to a layout?
 */
function setupHtmlEditor(editor, templateHasLayout) {
  const Mode = ace.require('ace/mode/mustachio').Mode
  const mode = new Mode({
    fragmentContext: templateHasLayout,
  })
  setupEditor(editor, mode)
}

/**
 * @param {object} editor - Ace editor
 * @param {object} mode - Ace mode
 */
function setupEditor(editor, mode) {
  editor.setTheme('ace/theme/pm-slate')

  const session = editor.getSession()
  session.setMode(mode)
  session.setTabSize(2)
  session.setUseWrapMode(true)
  session.setUseSoftTabs(true)
}

/**
 * @param {object} error
 * @param {number} [error.line]
 * @param {number} [error.character_position]
 * @param {string} error.message
 */
function formatErrorMessage(error) {
  if (error.line > 0 && error.character_position > 0) {
    return `Line ${error.line}, character ${error.character_position}: ${error.message}`
  } else {
    return error.message
  }
}

$(Templates.init)
